import {
  PrimaryUser,
  BuyFlowUser,
  JwtLoginSuccessResponse,
} from "features/types";
import { StyleSheet } from "react-native";
import authServices from "services/auth.services";
import { setStoredAuth } from "utils/storageUtils";
export const emailEqual = (
  emailOne: string | null,
  emailTwo: string | null
) => {
  if (emailOne === null || emailTwo === null) {
    return false;
  }
  return emailOne.toLowerCase() === emailTwo.toLowerCase();
};

export const emailExistsInSecondaryUsers = (
  email: string,
  secondaryUsers: BuyFlowUser[]
) => {
  const exists = secondaryUsers.some((user) => emailEqual(user.email, email));
  return exists;
};

export const calculateSecondardUsersPlanQuantity = (
  secondaryUsers: BuyFlowUser[]
) => {
  return secondaryUsers.reduce((current, next) => {
    return (current += next.quantity || 0);
  }, 0);
};

export const getTotalPlanPackageCount = (
  primaryUser: PrimaryUser,
  secondaryUsers: BuyFlowUser[]
) => {
  const secondaryUsersPlanQuantities =
    calculateSecondardUsersPlanQuantity(secondaryUsers);
  const newTotalPlanPackageQuantity =
    primaryUser.quantity! + secondaryUsersPlanQuantities + 1;
  return newTotalPlanPackageQuantity;
};

export const planPackageIdArray = (quantity: number, id: number): number[] =>
  new Array(quantity).fill(id);

export const styles = StyleSheet.create({
  inputWrapper: {
    marginBottom: 15,
  },
  errorText: {
    color: "red",
    fontSize: 13,
    marginBottom: 15,
  },
});

export const setUserToken = async (primaryUser: PrimaryUser) => {
  const loginResponse = (await authServices.login({
    username: primaryUser.email!,
    password: primaryUser.password!,
  })) as JwtLoginSuccessResponse;
  // Apis will have access to token now
  setStoredAuth(loginResponse);
  return loginResponse;
};
